import WidgetError from "auto-widget-framework/src/Error/WidgetError";
import WidgetStepPluginDefinition
  from "auto-widget-framework/src/Plugin/WidgetStep/WidgetStepPluginDefinition";

export default class WidgetFormStepPluginDefinition extends WidgetStepPluginDefinition {

  constructor(definition) {
    super(definition);

    if (!definition.form_id) {
      throw new WidgetError(`Missing form_id for widget from step definition '${definition.id}'.`);
    }

    this.formId = definition.form_id;
  }

  getFormId() {
    return this.formId;
  }

  /**
   * @inheritDoc
   */
  static getType() {
    return super.getType();
  }
}
